import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextInput, Label, Button } from 'flowbite-react';
import { authApi } from '../../api/auth';

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await authApi.forgotPassword(identifier);
      setSuccess(true);
      setError(null);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#1e3a8a] relative overflow-hidden">
      <div className="relative z-10 bg-white rounded-t-[40px] p-6 w-full mt-20">
        <h2 className="text-2xl font-bold text-center mb-6">Forgot Password</h2>
        
        <form onSubmit={handleSubmit} className="space-y-5 px-6">
          {error && (
            <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
              {error}
            </div>
          )}
          
          {success && (
            <div className="text-green-600 text-sm bg-green-50 p-3 rounded-md">
              Password reset instructions have been sent.
            </div>
          )}

          <div>
            <Label htmlFor="identifier">Email or Phone Number</Label>
            <TextInput
              id="identifier"
              type="text"
              required
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="Enter your email or phone number"
            />
          </div>

          <Button type="submit" className="w-full bg-blue-800">
            Reset Password
          </Button>

          <div className="text-center">
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="text-blue-600 hover:underline"
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 